import { filter, includes, isEmpty, isNil, sortBy } from 'lodash'

import {
  MENU_CURATION_TASK_STATUS,
  MENU_CURATION_TASK_TAGS,
} from '../../menu-curation-tasks/constants'
import { MENU_ALLOCATION_STATUS } from '../constants'

const computeMenuAllocationStatus = (menuCurationTask, priorityTaskId) => {
  const allocations = sortBy(
    filter(
      menuCurationTask.priorityTaskAllocations,
      allocation => allocation.priorityTask?.id === priorityTaskId,
    ),
    'isDone',
  )

  if (isEmpty(allocations)) {
    return MENU_ALLOCATION_STATUS.NOT_ALLOCATED.label
  }

  if (
    menuCurationTask.taskStatus === MENU_CURATION_TASK_STATUS.RESOLVED.value
  ) {
    return MENU_ALLOCATION_STATUS.ALLOCATED_COMPLETED.label
  }

  const isMenuTaskInProgress = includes(
    [
      MENU_CURATION_TASK_STATUS.TIER_ONE_IN_PROGRESS.value,
      MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_CURATION_IN_PROGRESS.value,
      MENU_CURATION_TASK_STATUS.UNKNOWN_WORDS_QA_IN_PROGRESS.value,
      MENU_CURATION_TASK_STATUS.CURATION_IN_PROGRESS.value,
      MENU_CURATION_TASK_STATUS.QA_IN_PROGRESS.value,
      MENU_CURATION_TASK_STATUS.QC_IN_PROGRESS.value,
    ],
    menuCurationTask.taskStatus,
  )
  const currentAllocation = allocations[0]

  if (
    !isNil(currentAllocation) &&
    !currentAllocation.isDone &&
    !isMenuTaskInProgress
  ) {
    return MENU_ALLOCATION_STATUS.ALLOCATED_NOT_STARTED.label
  }

  if (
    !isNil(currentAllocation) &&
    !currentAllocation.isDone &&
    isMenuTaskInProgress &&
    includes(menuCurationTask.tags, MENU_CURATION_TASK_TAGS.IS_OVERDUE.value)
  ) {
    return MENU_ALLOCATION_STATUS.ALLOCATED_OVERDUE.label
  }

  if (
    !isNil(currentAllocation) &&
    !currentAllocation.isDone &&
    isMenuTaskInProgress
  ) {
    return MENU_ALLOCATION_STATUS.ALLOCATED_IN_PROGRESS.label
  }

  if (!isNil(currentAllocation) && currentAllocation.isDone) {
    return MENU_ALLOCATION_STATUS.ALLOCATED_COMPLETED.label
  }

  return null
}

export default computeMenuAllocationStatus
